/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientAttributeType } from 'app/shared/model/patient-attribute-type.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IPatientAttribute {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  value?: string | null;
  comments?: string | null;
  type?: IPatientAttributeType | null;
  patient?: IGlucoUser | null;
  clinicalDictionary?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IPatientAttribute> = {
  active: false,
};
